import { ActivityGame, GameProvider } from "../game"
import { NavigateFunction } from "react-router-dom"
import { buildRelativeUrl } from "../../../common/utils/web-utils"
import { apiClient } from "../../../infra/api-client"
import { BASE_URL } from "../../../global"
import { getAuthUserInfo } from "../../../infra/security/auth-user-token"


export class MygoorooGameLauncher {


  static async launch(game: ActivityGame, navigate: NavigateFunction) {

    if (game.providerId !== GameProvider.MYGOOROO) {
      console.info(`unexpected game provider id. expected: ${GameProvider.MYGOOROO}, actual: ${game.providerId}`)
      return
    }

    if(game.providerGameId === 'times-table') {
      const payload = {
        student_key: getAuthUserInfo()?.student_key,
        provider_id: GameProvider.MYGOOROO,
        scope: ['login']
      }

      const response = await apiClient.post( BASE_URL + 'games/createProviderToken', payload);
      const token = response.data;
      if(token) {
        const params = {
          token: token,
        }

        // need to use anchor instead.
        // this is because safari blocks window.open if not part of a user action
        const url = buildRelativeUrl(game.link, params);
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
        // window.open(url)
      }

    }

  }

}